"use strict";
import { Action } from "../actions";
export default function canvasReducer(canvas = {}, action) {
  switch (action.type) {
    case Action.CANVAS_SIZE_CHANGED: {
      return Object.assign({}, canvas, {
        width: action.width,
        height: action.height
      });
    }
    default:
      return canvas;
  }
}
